import _extends from '@babel/runtime/helpers/esm/extends';
import React from 'react';
import { PropTypes, describe } from 'react-desc';
import CheckableGroup from '@elliemae/ds-shared/CheckableGroup';

function RadioGroup(props) {
  return /*#__PURE__*/React.createElement(CheckableGroup, _extends({}, props, {
    multi: false
  }));
}

var props = {
  /* The item selected */
  active: PropTypes.arrayOf(PropTypes.string).description('the item selected'),

  /* Handler when a user checks an item */
  onCheck: PropTypes.func.description('Handler when a user checks an item')
};
RadioGroup.propTypes = props;
var DSMenuRadioGroupWithSchema = describe(RadioGroup);
DSMenuRadioGroupWithSchema.propTypes = props;

export default RadioGroup;
export { DSMenuRadioGroupWithSchema };
//# sourceMappingURL=RadioGroup.js.map
